
import MapCommand from './MapCommand';

export default class MapCommandSetLayerParams extends MapCommand {

    constructor(options) {
        super(options);
        this._name = 'SET_LAYER_PARAMS';
    }

    execute(olMap, params) {
        let map = olMap.getMap();

        map.getLayers().forEach(layer => {
            if (params.layer === layer.get('id')) {
                let source = layer.getSource();
                if (source.getParams) {
                    let newParams = {
                        ...source.getParams(),
                        ...params.params
                    }
                    source.updateParams(newParams);
                }
            }
        });
    }
}
